import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { languages } from 'app/app.routes';
import { API_MAP } from 'app/core/helpers/api.map';
import { map } from 'rxjs';
import { HomeService } from './home.service';

export const HomeResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let url = languages.find((c) => c.ContainerName.toLowerCase() == state.url.replaceAll('/','')) ? state.url + '/home' : state.url;
  return inject(HomeService)
    .get(API_MAP.home + url)
    .pipe(map(() => true));
};
